import { graphql } from 'gatsby';
import React, { useEffect } from 'react';
import Marquee from 'react-fast-marquee';
import { VIEWPORT } from '~/utils/constants';
import { useViewport } from '~/utils/viewport-provider';

type CarouselLogoProps = {
  carousel_items: ImageField<RegularImage>[];
  direction: 'left' | 'right';
  height: number;
  mobile_height: number;
  speed: number;
  gap: number;
  mobile_gap: number;
};

const CarouselLogo: React.FC<CarouselLogoProps> = ({
  carousel_items,
  direction = 'left',
  height = 4,
  mobile_height = 3,
  speed = 80,
  gap = 2,
  mobile_gap = 1,
}) => {
  const { viewport } = useViewport();
  const [responsiveHeight, setResponsiveHeight] = React.useState(
    viewport.device === VIEWPORT.mobile ? mobile_height : height
  );
  const [responsiveHalfGap, setResponsiveHalfGap] = React.useState(
    0.5 * (viewport.device === VIEWPORT.mobile ? mobile_gap : gap)
  );

  useEffect(() => {
    if (viewport.device === VIEWPORT.mobile) {
      setResponsiveHeight(mobile_height);
      setResponsiveHalfGap(mobile_gap * 0.5);
    } else {
      setResponsiveHeight(height);
      setResponsiveHalfGap(gap * 0.5);
    }
  }, [viewport]);

  return (
    <Marquee
      autoFill={true}
      className='carousel-logo'
      direction={direction}
      speed={speed}
    >
      {carousel_items.map((item, index) => (
        <div
          key={index}
          style={{
            marginLeft: `${responsiveHalfGap}rem`,
            marginRight: `${responsiveHalfGap}rem`,
          }}
          className='carousel-logo__item'
        >
          <img
            style={{ height: `${responsiveHeight}rem` }}
            src={item.src}
            alt={item.alt}
          />
        </div>
      ))}
    </Marquee>
  );
};

export const carouselLogoFragment = graphql`
  fragment CarouselLogoFragment on Block {
    _template
    speed
    direction
    gap
    mobile_gap
    height
    mobile_height
    carousel_items {
      src
      alt
      offset {
        horizontal
        vertical
      }
      scale {
        x
        y
      }
    }
  }
`;

export default CarouselLogo;
